let echarts = require('echarts/lib/echarts');
// require('echarts/theme/dark'); // 按需加载不要加载echarts的全部主题
import customed1 from "@/assets/theme/customed1.json" //自定义echarts主题1
import customed2 from "@/assets/theme/customed2.json" //自定义echarts主题1
echarts.registerTheme("theme1",customed1);
echarts.registerTheme("theme2",customed2);
/**
 * @description echarts主题切换设置
 * @author cy
 * @param { string } echartsInstanceObj echarts实例对象
 * @param { string } instance echarts实例 
 * @param { string } id 承载echarts实例的DOM ID
 * @param { string } option 配置项
 * @returns 
 */
export default function echartsThemeSet(echartsInstanceObj,inTab = false) {
    Object.keys(echartsInstanceObj).forEach(key => {
        if(!!echartsInstanceObj[key]["instance"] || inTab){
            if(!inTab){
                echartsInstanceObj[key]["instance"].dispose();
            }
            if(!!document.getElementById(echartsInstanceObj[key]["id"]) 
            && document.getElementById(echartsInstanceObj[key]["id"]).offsetWidth === 0){ // 宽度为0时说明未在current-TAB
                echartsInstanceObj[key]["instance"] = ''
            }else{
                echartsInstanceObj[key]["instance"] = echarts.init(document.getElementById(echartsInstanceObj[key]["id"]),localStorage.getItem('echartsTheme'));
                echartsInstanceObj[key]["instance"].setOption(echartsInstanceObj[key]["option"]);
            }
        }
    })
    return echartsInstanceObj;
}